var $caa152f7f8e96c85$exports = {};
$caa152f7f8e96c85$exports = {
    "breadcrumbs": `Breadcrumb`
};


export {$caa152f7f8e96c85$exports as default};
//# sourceMappingURL=it-IT.module.js.map
